export const createDiscussionKindState = () => ({
    name: '',
    display: '',
    is_public: false,
});
